module.exports = __webpack_public_path__ + "static/media/channel-bank.2fbc2093.svg";